import { render, staticRenderFns } from "./StripeCheckoutEmbeddedReturn.vue?vue&type=template&id=1ed26396&scoped=true&"
import script from "./StripeCheckoutEmbeddedReturn.vue?vue&type=script&lang=js&"
export * from "./StripeCheckoutEmbeddedReturn.vue?vue&type=script&lang=js&"
import style0 from "./StripeCheckoutEmbeddedReturn.vue?vue&type=style&index=0&id=1ed26396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed26396",
  null
  
)

export default component.exports